import React from "react";

export default function MySQL_SUBSTR() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_SUBSTR</h1>
      <p>This is the MySQL_SUBSTR component generated from the SQL JSON.</p>
    </div>
  );
}
